import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import Icon from 'ol/style/Icon.js';
import Style from 'ol/style/Style.js';


function lCreateStyle(src, img) {
    return new Style({
        image: new Icon({
            anchor: [0.5, 46],
            anchorXUnits: 'fraction',
            anchorYUnits: 'pixels',
            src: src,
            img: img,
            crossOrigin: 'anonymous',
        }),
    });
}

var vectorLayer = new VectorLayer({
    source: new VectorSource(),
    style: function (feature) {
        return feature.get('style');
    },
    visible : true,
    title : "Bâtiments"
});

export const batimentVectorLayer = vectorLayer;
export const createStyle = lCreateStyle;